import { useState } from "react"
import { Mail, Linkedin, ArrowRight } from "lucide-react"
import Header from "../components/Header"
import Footer from "../components/Footer"
import EmailModal from "../components/SupportEmailModal"

const FONT = '"Plus Jakarta Sans", sans-serif'

const SupportPage = () => {
  const [showEmailModal, setShowEmailModal] = useState(false)

  const supportContacts = [
    {
      id: 1,
      type: "Email Support",
      contact: "resolut.ai@gmail.com",
      icon: <Mail size={20} />,
      href: "mailto:resolut.ai@gmail.com",
      description: "Get in touch for any questions or support needs",
      onClick: (e) => { e.preventDefault(); setShowEmailModal(true) },
    },
    {
      id: 2,
      type: "LinkedIn",
      contact: "Connect with us",
      icon: <Linkedin size={20} />,
      href: "",
      description: "Connect directly for professional inquiries",
    },
  ]

  return (
    <div className="min-h-screen flex flex-col" style={{ background: "#FDFAF8", fontFamily: FONT }}>
      <Header />

      <div className="flex-1 max-w-4xl mx-auto w-full px-6 lg:px-8 pt-36 pb-24">

        {/* Page heading */}
        <div className="mb-16">
          <p className="text-[11px] font-semibold tracking-[0.2em] uppercase text-zinc-400 mb-4" style={{ fontFamily: FONT }}>
            Support
          </p>
          <h1
            className="text-3xl sm:text-4xl font-semibold tracking-[-0.02em] text-zinc-900 mb-3"
            style={{ fontFamily: FONT }}
          >
            How can we help?
          </h1>
          <p className="text-[15px] text-zinc-500 leading-relaxed max-w-sm" style={{ fontFamily: FONT }}>
            Reach out through any channel below — we typically respond within 24 hours.
          </p>
        </div>

        {/* Contact cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12">
          {supportContacts.map((contact) => (
            <div
              key={contact.id}
              className="bg-white rounded-xl border border-zinc-200 p-6 flex flex-col gap-4"
            >
              <div className="w-10 h-10 rounded-lg bg-zinc-100 flex items-center justify-center text-zinc-600 flex-shrink-0">
                {contact.icon}
              </div>

              <div>
                <h3 className="text-[15px] font-semibold text-zinc-900 mb-1" style={{ fontFamily: FONT }}>
                  {contact.type}
                </h3>
                <p className="text-[13px] text-zinc-500 leading-relaxed" style={{ fontFamily: FONT }}>
                  {contact.description}
                </p>
              </div>

              <a
                href={contact.href}
                onClick={contact.onClick}
                target={contact.type === "LinkedIn" ? "_blank" : "_self"}
                rel={contact.type === "LinkedIn" ? "noopener noreferrer" : ""}
                className="inline-flex items-center gap-1.5 text-[13px] font-semibold text-zinc-900 hover:text-zinc-600 transition-colors mt-auto"
                style={{ fontFamily: FONT }}
              >
                {contact.contact} <ArrowRight size={13} />
              </a>
            </div>
          ))}
        </div>

        {/* Response time note */}
        <div
          className="rounded-xl border border-zinc-200 p-8"
          style={{ background: "#F5EFE0" }}
        >
          <h2 className="text-[17px] font-semibold text-zinc-900 mb-2" style={{ fontFamily: FONT }}>
            Quick response guaranteed
          </h2>
          <p className="text-[14px] text-zinc-500 leading-relaxed max-w-md" style={{ fontFamily: FONT }}>
            We respond to all inquiries within 24 hours. For urgent matters, reach out directly via email.
          </p>
        </div>
      </div>

      <EmailModal isOpen={showEmailModal} onClose={() => setShowEmailModal(false)} />
      <Footer />
    </div>
  )
}

export default SupportPage
